/**
 * Store Zustand — Máquina de Estados de Autenticación y Cooldown OTP (Paso 5.7)
 */

import { create } from 'zustand';

interface AuthFlowState {
  step: 'CREDENTIALS' | 'MFA_CHALLENGE' | 'OTP_PHONE' | 'OTP_VERIFY';
  ticketPreauth: string | null;
  telefonoOtp: string;
  cooldownSeconds: number;
  isSubmitting: boolean;
  errorMessage: string | null;
  setStep: (step: AuthFlowState['step']) => void;
  setTicketPreauth: (ticket: string | null) => void;
  setTelefonoOtp: (tel: string) => void;
  setCooldownSeconds: (sec: number) => void;
  setIsSubmitting: (val: boolean) => void;
  setErrorMessage: (msg: string | null) => void;
  resetAuthFlow: () => void;
}

export const useAuthFlowStore = create<AuthFlowState>((set) => ({
  step: 'CREDENTIALS',
  ticketPreauth: null,
  telefonoOtp: '+57',
  cooldownSeconds: 0,
  isSubmitting: false,
  errorMessage: null,

  setStep: (step) => set({ step, errorMessage: null }),
  setTicketPreauth: (ticketPreauth) => set({ ticketPreauth }),
  setTelefonoOtp: (telefonoOtp) => set({ telefonoOtp }),
  setCooldownSeconds: (cooldownSeconds) => set({ cooldownSeconds }),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setErrorMessage: (errorMessage) => set({ errorMessage }),
  resetAuthFlow: () =>
    set({
      step: 'CREDENTIALS',
      ticketPreauth: null,
      cooldownSeconds: 0,
      isSubmitting: false,
      errorMessage: null,
    }),
}));
